import React from 'react';
import WorldMap from './WorldMap';
import './MapView.css';

const MapView = () => {
    return (
        <div className="map-view-container">
            <div className="map-card">
                <WorldMap />
            </div>
            <div className="map-legend">
                <p><strong>Note:</strong> Countries are colored based on the number of items in your collection.</p>
            </div>
        </div>
    );
};

export default MapView;